import Image from "next/image";
import React from "react";

import styles from "./styles.module.css";

export const SubcategoriesLogos = ({ logos }: { logos: string[] }) => {
  return (
    <div className={styles.brandsLogoContainer}>
      {logos?.map((logo) => (
        <figure key={logo} className={styles.brandLogo}>
          <Image src={logo} alt={logo} fill={true} />
        </figure>
      ))}
    </div>
  );
};
